/*
 * -----------------------------------------------------------------------
 *  <copyright file="indications-gridtsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { orderBy } from '@progress/kendo-data-query';
import React, { useEffect, useState } from 'react';
import { useTranslation, useGridCells } from 'hooks';
import { restructuredUpdatedCreatedBy } from '@utils-clean/update-users-array';
import ExpandableGrid from 'views/components/core/expandable/grid';

import './styles.scss';

const IndicationsGrid = ({ indications, rowActions }: any) => {
    const { t } = useTranslation();
    const { DateCell } = useGridCells();
    const newData = restructuredUpdatedCreatedBy(indications);
    const indicationData = orderBy(newData, [{ field: 'name', dir: 'asc' }]);

    return (
        <ExpandableGrid
            customKey="indications-grid"
            id="indications"
            rowActions={rowActions}
            groupable={false}
            showPager
            scrollable="scrollable"
            reorderable
            addScroll
            pageable={false}
            resizable
            options={{
                allowExcelExport: false,
                allowExpandCollapseAll: false,
                useFilterChips: false,
            }}
            items={indicationData}
            columns={[
                {
                    label: t('admin:indication'),
                    field: 'name',
                    id: 'indication-name',
                    minWidth: 160,
                    lockedByDefault: true,
                },
                {
                    label: t('ra:createdDate'),
                    id: 'indications-created',
                    minWidth: 180,
                    field: 'created',
                    cells: { data: DateCell },
                    filter: 'date',
                },
                {
                    label: t('ra:createdBy'),
                    id: 'indications-createdby',
                    field: '_createdByString',
                    minWidth: 180,
                },
                {
                    label: t('ra:updatedDate'),
                    field: 'updated',
                    id: 'indications-updated',
                    minWidth: 180,
                    filter: 'date',
                    cells: { data: DateCell },
                },
                {
                    label: t('ra:updatedBy'),
                    id: 'indications-updatedby',
                    field: '_updatedByString',
                    minWidth: 180,
                },
                {
                    field: 'recordId',
                    label: t('id'),
                    id: 'indications-id',
                    filter: 'numeric',
                    minWidth: 100,
                    showByDefault: false,
                },
            ]}
        />
    );
};

export default IndicationsGrid;
